import { render, staticRenderFns } from "./mapform.vue?vue&type=template&id=0b0b020f&scoped=true&"
import script from "./mapform.vue?vue&type=script&lang=js&"
export * from "./mapform.vue?vue&type=script&lang=js&"
import style0 from "./mapform.vue?vue&type=style&index=0&id=0b0b020f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b020f",
  null
  
)

export default component.exports